import { render, staticRenderFns } from "./gradient_picker.vue?vue&type=template&id=1465d1a2&scoped=true&"
import script from "./gradient_picker.vue?vue&type=script&lang=js&"
export * from "./gradient_picker.vue?vue&type=script&lang=js&"
import style0 from "./gradient_picker.vue?vue&type=style&index=0&id=1465d1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1465d1a2",
  null
  
)

export default component.exports